/**
 *
 * @param {*} string makes up an array
 * @param {*} userInputForm from command modal form
 * @returns {boolean} true if outRotation matches userInput form desire
 */
export const rotationEvaluation = (string, userInputForm) =>
  string.outRotation === (userInputForm.outRotation === 'true')
